import React from "react";
import Loadable from "../../react-loadable";

const WeaProgress = Loadable({
  loader: () => import("./Progress"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaProgress;



// WEBPACK FOOTER //
// ./ecology9/wea-progress/index.js